import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import ProductInfoAvailable from "./ProductInfoAvailable";
import ProductInfoLeasing from "./Additional/ProductInfoLeasing";
import ProductInfoDeliveryFrom from "./Additional/ProductInfoDeliveryFrom";
import ProductInfoOrderWithin from "./Additional/ProductInfoOrderWithin";
import ProductInfoAvailability from "./Additional/ProductInfoAvailability";
import ProductInfoPrices from "./ProductInfoPrices";
import ProductInfoNotAvailable from "./ProductInfoNotAvailable";
import {useAppDispatch, useAppSelector} from "../../../services/hooks";
import {useTranslation} from "react-i18next";
import {setModalShow} from "../../../stores/user/userSlice";
import {createContext, useContext} from "react";
import {InfoProductOptions} from "../../../stores/product/productSlice.types.ts";


type ProductCtx = { price?: object | null, options?: InfoProductOptions };
const ProductContext = createContext<ProductCtx>({});

export default function ProductInfo() {
    const {t} = useTranslation('productPage');
    const code = useAppSelector((state) => state.product.data.code);
    const options = useAppSelector((state) => state.product.data.options);
    const price = useAppSelector((state) => state.product.data.price);
    const currency = useAppSelector((state) => state.user.currency);

    return (
        <ProductContext.Provider value={{price, options}}>
            <Col xs={{span: 12, order: 1,}} md={4} lg={{order: 1}} xl={{order: 2}} className="my-3">
                <Row className="text-center">
                    <span><strong>{t('code')}</strong> {code}</span>

                    <ProductInfoPrice/>
                </Row>
                <Row>
                    <ProductInfoCart/>
                </Row>
                <Row className="ps-2 text-lg-start text-center text-opacity-75">
                    {!options.isOutOfStock && <>
                        <ProductInfoOrderWithin/>
                        <ProductInfoAvailability/>
                    </>}
                    {Object(price).net < 10000 && currency === 'PLN' && <ProductInfoLeasing/>}
                    <ProductInfoDeliveryFrom/>
                </Row>
            </Col>
        </ProductContext.Provider>
    )
}

const ProductInfoPrice = () => {
    const dispatch = useAppDispatch();
    const product = useProduct();

    if (product.options?.isHiddenPrice) {
        return (
            <Col className="text-center py-5" onClick={() => dispatch(setModalShow(true))}
                 style={{cursor: "pointer"}}>
                Aby zobaczyć ceny, zaloguj się na swoje konto. Jeśli nie masz konta, możesz je tutaj założyć.
            </Col>
        );
    }

    if (!product.price || !Object(product.price).net) {
        return (
            <div className="my-5 text-center">
                Skontaktuj się z nami, aby zakupić ten produkt.
            </div>
        );
    }

    return (
        <>
            <ProductInfoPrices/>
        </>
    );
};


const ProductInfoCart = () => {
    const product = useProduct();

    if (!product.price || product.options?.isHiddenPrice) {
        return <div/>;
    }

    return product.options?.isOutOfStock
        ? <ProductInfoNotAvailable/>
        : <ProductInfoAvailable/>;
};

function useProduct() {
    return useContext(ProductContext);
}